import { render } from "./ResetPasswordModal.vue?vue&type=template&id=4311c44d&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=4311c44d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4311c44d"],['__file',"ResetPasswordModal.vue"]])

export default __exports__